<script>
    export let id = "";
    export let label = "";
    export let items = [];
    export let value = "";
    export let containerStyles = "";
    export let size = 9;
    $: mappedItems = items.map((x) => ({ value: x[0], label: x[1] }));

    import Select from "svelte-select";
</script>

<div class="form-group">
    <label for="{id}_label" class="col-sm-3 control-label">{label}</label>
    <div class={`col-sm-${size}`}>
        <Select
            containerClasses="form-control"
            {containerStyles}
            id="{id}_select"
            items={mappedItems}
            bind:value
            isClearable={false}
            showIndicator={true}
        />
    </div>
    <slot />
</div>
